import React, { useEffect, useState } from 'react';
import "../../assets/styles/Search.css";
import SelectSearch from "react-select";
import Select from 'react-select';
import Popup from "reactjs-popup";
import { motion } from "framer-motion";
import Header from "../../components/Header.js";
import InfoUser from "../../components/Profile/InfoUser.js";
import DataConfirm from "../../components/Profile/DataConfirm.js";
import Collapsible from "react-collapsible";
import Swal from "sweetalert2";
import iconSearch from "../../icons/icon-search.png";
import iconBack from "../../icons/icon-back.png";
import { useLocation, useNavigate } from "react-router-dom";
import Loading from "../../components/helper/Loading.js"
import { config } from "../../config.js";
import { apiCheckAccount, apiGetSetting } from "../../services/api.service.js";
import { apiConfirmUpdate, apiUpdateAccount, apiCheckDataAccount, apiFormUpdateAccount, apiGetRequestHistory, apiGetBanks } from "../../services/api.service.js";
// import iconArrow from "../../icons/";
import {
  Box,
  Button,
  FormControl,
  MenuItem,
  // Select,
  TextField,
  Typography,
  IconButton,
} from "@mui/material";
import { AddPhotoAlternateOutlined, Close } from "@mui/icons-material";
import iconArrow from "../../icons/icon-arrow.png";
import iconSendMail from "../../icons/icon-send-mail.png";
import iconSendPhone from "../../icons/icon-send-phone.png";
import iconImage from "../../icons/icon-send-image.png";
import iconClose from "../../icons/icon-close.png";
import iconWarning from "../../icons/icon-warning.png";
import iconSuccess from "../../icons/icon-success.png";
import HomeIcon from '@mui/icons-material/Home';
import HtmlNote from "../../components/Profile/HtmlNote.js";

function ChangeInfo() {
  const location = useLocation();
  const { userName, data, webSetting, typeModal: initialTypeModal } = location.state || {};
  const [typeModal, setTypeModal] = useState(initialTypeModal || "");
  const isContactInfoFlow = initialTypeModal === "contact_info";
  const [openResult, setOpenResult] = useState(false);
  const [checkConfirm, setCheckConfirm] = useState(false);
  const [isSendMail, setIsSendMail] = useState(true);
  const [openConfirm, setOpenConfirm] = useState(false);
  const [openUploadFile, setOpenUploadFile] = useState(false);
  const [previews, setPreviews] = useState([]);
  const [selectedImage, setSelectedImage] = useState([]);
  const [selectedFiles, setSelectedFiles] = useState([]);
  const [loading, setLoading] = useState(false);
  const [infoFileUpload, setInfoFileUpload] = useState("");
  const [idUserUpdate, setIdUserUpdate] = useState("");
  const [submittedRequest, setSubmittedRequest] = useState(null);
  const [pollingMinutesLeft, setPollingMinutesLeft] = useState(15);
  const [isRefreshingRequest, setIsRefreshingRequest] = useState(false);
  const [requestRefreshMessage, setRequestRefreshMessage] = useState("");
  const [recentRequests, setRecentRequests] = useState((data?.recent_requests || []).slice(0, 2));
  const [placeholderCheckBankNumber, setPlaceholderCheckBankNumber] = useState("Nhập số tài khoản");
  const navigate = useNavigate();
  const [errors, setErrors] = useState({});
  const originalDataUpdate = {
    name: "",
    province: "",
    bank_type_change: "",
    bank_name: "",
    bank_number: "",
    email: "",
    phone_number: "",
  };
  const originalDesChangeBank = {
    title_change_bank: "THAY ĐỔI THÔNG TIN NGÂN HÀNG",
    bank_name: "Tên Ngân Hàng Mới",
    bank_number: "Số Tài Khoản Mới",
  };
  const desBankNew = {
    title_change_bank: "THÊM THÔNG TIN NGÂN HÀNG",
    bank_name: "Tên Ngân Hàng Mới",
    bank_number: "Số Tài Khoản Ngân Hàng Mới",
  };
  const desBankRemove = {
    title_change_bank: "XÓA SỐ TÀI KHOẢN NGÂN HÀNG",
    bank_name: "Tên Ngân Hàng Cần Xóa",
    bank_number: "Số Tài Khoản Cần Xóa",
  };
  const [desChangeBank, setDesChangeBank] = useState(originalDesChangeBank);
  const [dataUpdate, setDataUpdate] = useState(originalDataUpdate);
  const [timesCheckData, setTimesCheckData] = useState(0);
  const [dataCheck, setDataCheck] = useState({
    name: "",
    province: "",
    bank_name: "",
    bank_number: "",
    email: "",
    phone_number: "",
  });
  
  
  const [user, setUser] = useState({
    account: userName,
    update_type: "",
    status: "",
    auto_check: "",
    send_type: "",
  });

  const USDT_WALLET = "Ví USDT"; // ok9 chọn ví USDT chung ô ngân hàng, không có mã ngân hàng
  const [banks, setBanks] = useState([]); // danh sách ngân hàng cho khách chọn: [{ code, name }]
  const bankOptions = [
    { value: USDT_WALLET, label: USDT_WALLET },
    ...banks.map((bank) => ({ value: bank.code, label: bank.name })),
  ];

  useEffect(() => {
    const fetchBanks = async () => {
      setBanks(await apiGetBanks());
    };
    fetchBanks();
  }, []);

  // danh sách mục thông tin tài khoản không được phép thay đổi (BE trả về khi check tài khoản)
  const disabledUpdateTypes = data?.disabled_update_types || [];

  // mô tả file upload và số ảnh tối thiểu theo mục thông tin khách đang chọn (setup ở admin)
  const uploadSetting = webSetting?.upload_descriptions || {};
  const uploadConfig = uploadSetting.by_update_type?.[typeModal] || {};
  const uploadDescriptions = [];
  (uploadConfig.keys || []).forEach((key) => {
    const item = (uploadSetting.items || []).find((item) => item.key === key);
    if (item?.content) uploadDescriptions.push(item.content);
  });
  // chưa setup thì mặc định như cũ: tổng số mô tả trừ 1, tối thiểu 1 ảnh
  const minFiles = uploadConfig.min_files ?? Math.max(uploadDescriptions.length - 1, 1);

  // chọn ngân hàng: lưu cả mã ngân hàng (bank_code) và tên ngân hàng (bank_name), ví USDT không có mã
  const getSelectedBank = (option) => {
    if (option?.value === USDT_WALLET) return { bank_code: "", bank_name: USDT_WALLET };
    const bank = banks.find((item) => item.code === option?.value);
    return { bank_code: bank ? bank.code : "", bank_name: bank ? bank.name : "" };
  };
  const selectBankCheck = (option) => {
    const selected = getSelectedBank(option);
    setPlaceholderCheckBankNumber(selected.bank_name === USDT_WALLET ? "mã Ví USDT" : "Nhập số tài khoản");
    setDataCheck({ ...dataCheck, ...selected });
  };
  const selectBankUpdate = (option) => {
    const selected = getSelectedBank(option);
    if (selected.bank_name === USDT_WALLET) {
      desChangeBank.bank_number = desChangeBank.bank_number.replace("Số Tài Khoản", "Mã Ví USDT");
    } else {
      desChangeBank.bank_number = desChangeBank.bank_number.replace("Mã Ví USDT", "Số Tài Khoản");
    }
    setDataUpdate({ ...dataUpdate, ...selected });
  };

  const inputDataCheck = (event) => {
    let { name, value } = event.target;
    if ("bank_name" === name && value === "Ví USDT") {
      setPlaceholderCheckBankNumber("mã Ví USDT");
    } else {
      setPlaceholderCheckBankNumber("Nhập số tài khoản");
    }
    if (name === "email") {
      value = value.toLowerCase()
    }
    setDataCheck({
      ...dataCheck,
      [name]: value,
    });
  };
  
  const inputDataUpdate = (event) => {
    const { name, value } = event.target;
    if ("bank_name" === name && value === "Ví USDT") {
      desChangeBank.bank_number=desChangeBank.bank_number.replace("Số Tài Khoản", "Mã Ví USDT");
    } else {
      desChangeBank.bank_number=desChangeBank.bank_number.replace("Mã Ví USDT", "Số Tài Khoản");
    }
    setDataUpdate({
      ...dataUpdate,
      [name]: value,
    });
    if (name == "bank_type_change") {
      switch (value) {
        case "Thêm số tài khoản": setDesChangeBank(desBankNew)
        break;
        case "Xóa số tài khoản": setDesChangeBank(desBankRemove)
        break;
        case "Đổi số tài khoản": setDesChangeBank(originalDesChangeBank)
        break;
        default: setDesChangeBank(originalDesChangeBank)
      }
    }
  };
  let contentUpdate;

  useEffect(() => {
    updateUserField("update_type", typeModal === "contact_info" ? "" : typeModal)
  }, [isContactInfoFlow, typeModal]);

  useEffect(() => {
    if (!openConfirm || !submittedRequest?.request_code || submittedRequest.status !== "no_process") return undefined;
    let checks = 0;
    const intervalId = setInterval(async () => {
      checks += 1;
      setPollingMinutesLeft(Math.max(20 - checks, 0));
      const result = await apiGetRequestHistory(user.account, submittedRequest.request_code);
      if (result?.code === 200 && result?.data?.request) {
        const request = result.data.request;
        setSubmittedRequest(request);
        setRecentRequests((items) => items.map((item) => item._request_code === request.request_code
          ? { ...item, status: request.status, verification_status: request.verification_status }
          : item));
      }
      if (checks >= 15) clearInterval(intervalId);
    }, 30 * 1000);
    return () => clearInterval(intervalId);
  }, [openConfirm, submittedRequest?.request_code, submittedRequest?.status, user.account]);

  const validateForm = (type = false, checkData = dataCheck) => {
    let errors = {};
    let formIsValid = true;

    // Kiểm tra trường Name
    if (!checkData.name) {
      formIsValid = false;
      errors.name = 'Vui lòng nhập Họ và Tên';
    }

    // Kiểm tra trường phone_number
    if (data.phone_number && type === "phone_number") {
      if (!checkData.phone_number) {
        formIsValid = false;
        errors.phone_number = 'Vui lòng nhập Số Điện Thoại';
      } else if (!/^\d{10}$/.test(checkData.phone_number)) {
        formIsValid = false;
        errors.phone_number = 'Số Điện Thoại không hợp lệ';
      }
    }

    // Kiểm tra trường email
    if (data.email && type === "mail") {
      if (!checkData.email) {
        formIsValid = false;
        errors.email = 'Vui lòng nhập Email';
      } else if (!/\S+@\S+\.\S+/.test(checkData.email)) {
        formIsValid = false;
        errors.email = 'Email không hợp lệ';
      }
    }

    // Kiểm tra trường bank_name
    if (!checkData.bank_name) {
      formIsValid = false;
      errors.bank_name = 'Vui lòng chọn Ngân Hàng';
    }

    // Kiểm tra trường bank_number
    if (!checkData.bank_number) {
      formIsValid = false;
      errors.bank_number = 'Vui lòng nhập Số Tài Khoản';
    }
    switch (typeModal) {
      case "full_name": // Kiểm tra trường Name update
      if (!dataUpdate.name) {
        formIsValid = false;
        errors.nameUpdate = 'Vui lòng nhập Họ và Tên mới';
      } else {
        contentUpdate = dataUpdate.name;
      }
      break;
      case "phone_number":// Kiểm tra trường phone_number
        if (!dataUpdate.phone_number) {
          formIsValid = false;
          errors.phoneNumberUpdate = 'Vui lòng nhập Số Điện Thoại mới';
        } else if (!/^\d{10}$/.test(dataUpdate.phone_number)) {
          formIsValid = false;
          errors.phoneNumberUpdate = 'Số Điện Thoại mới không hợp lệ';
        } else {
          contentUpdate = dataUpdate.phone_number;
        }
        break;
      case "email":// Kiểm tra trường email
        if (!dataUpdate.email) {
          formIsValid = false;
          errors.emailUpdate = 'Vui lòng nhập Email mới';
        } else if (!/\S+@\S+\.\S+/.test(dataUpdate.email)) {
          formIsValid = false;
          errors.emailUpdate = 'Email mới không hợp lệ';
        } else {
          contentUpdate = dataUpdate.email;
        }
        break;
      case "bank":// Kiểm tra value bank
        if (!dataUpdate.bank_type_change) {
          formIsValid = false;
          errors.bankTypeChange = 'Vui lòng chọn yêu cầu thay đổi';
        }
        if (!dataUpdate.bank_name) {
          formIsValid = false;
          errors.bankNameUpdate = 'Vui lòng chọn Ngân Hàng';
        }
        if (!dataUpdate.bank_number) {
          formIsValid = false;
          errors.bankNumberUpdate = 'Vui lòng nhập Số Tài Khoản';
        } else {
          contentUpdate = ( dataUpdate.bank_type_change + " - " + dataUpdate.bank_number + " - " + dataUpdate.bank_name )
        }
        break;
        case "birthday": // Kiểm tra trường birth day
          if (!dataUpdate.birth_day) {
            formIsValid = false;
            errors.birthDayUpdate = 'Vui lòng chọn ngày tháng năm sinh';
          } else {
            contentUpdate = dataUpdate.birth_day;
          }
          break;
        case "forget_password":
          contentUpdate = "Cấp lại mật khẩu đăng nhập";
          break;
        case "forget_password_withdraw":
          contentUpdate = "Cấp lại mật khẩu rút tiền";
          break;
        case "contact_info":
          formIsValid = false;
          errors.contactInfoType = "Vui lòng chọn thông tin cần thay đổi";
          break;
      default: break
    }
    console.log(errors)
    setErrors(errors);
    return formIsValid;
  };
  const modalConfirmUpdate = async (type, checkData = dataCheck) => {
    if (type === "files") {
      if (validateForm(type)) {
        user.send_type = "files";
        updateUserField("send_type", "files");
        updateUser("files");
      }
      return;
    }

    if (!validateForm("files")) {
      return;
    }

    const isEmail = type === "mail";
    const result = await Swal.fire({
      icon: "warning",
      title: isEmail
        ? "Vui lòng nhập Email đã liên kết"
        : "Vui lòng nhập Số Điện Thoại đã liên kết",
      // text: isEmail
      //   ? "Email này sẽ được dùng để xác thực thông tin."
      //   : "Số điện thoại này sẽ được dùng để xác thực thông tin.",
      input: isEmail ? "email" : "text",
      inputValue: isEmail ? checkData.email : checkData.phone_number,
      inputPlaceholder: isEmail ? "Email đã liên kết" : "Số Điện Thoại đã liên kết",
      showCancelButton: true,
      confirmButtonText: "Tiếp tục",
      cancelButtonText: "Quay lại",
      reverseButtons: true,
      inputValidator: (value) => {
        const normalizedValue = isEmail
          ? value.trim().toLowerCase()
          : value.trim().replace(/^(\+?84)/, "0");

        if (!normalizedValue) {
          return isEmail
            ? "Vui lòng nhập Email"
            : "Vui lòng nhập Số Điện Thoại";
        }
        if (isEmail && !/\S+@\S+\.\S+/.test(normalizedValue)) {
          return "Email không hợp lệ";
        }
        if (!isEmail && !/^\d{10}$/.test(normalizedValue)) {
          return "Số Điện Thoại không hợp lệ";
        }
        return undefined;
      },
    });

    if (result.isConfirmed) {
      const value = isEmail
        ? result.value.trim().toLowerCase()
        : result.value.trim().replace(/^(\+?84)/, "0");
      const nextDataCheck = {
        ...checkData,
        [isEmail ? "email" : "phone_number"]: value,
      };
      setDataCheck(nextDataCheck);
      updateUser(type, false, nextDataCheck);
    }
  }
  
  const updateUserField = (field, value) => {
    setUser((prevUser) => ({
      ...prevUser,
      [field]: value,
    }));
  };
  
  const openModalConfirm = (type) => {
    setOpenConfirm(true);
  };
  const confirmUpdateUser = async (body, type) => {
    setLoading(true)
    let updateInfo = await apiFormUpdateAccount(body, selectedFiles);
    setLoading(false)
    if (updateInfo?.request_code) {
      updateUserField("request_code", updateInfo.request_code);
      setIdUserUpdate(updateInfo.id || "");
      const newRequest = {
        _request_code: updateInfo.request_code,
        request_code: `xxxxxx${updateInfo.request_code.slice(-2)}`,
        update_type: user.update_type,
        send_type: user.send_type,
        status: "no_process",
        verification_status: "not_received",
      };
      setSubmittedRequest({ ...newRequest, request_code: updateInfo.request_code, note: "" });
      setRecentRequests((items) => [newRequest, ...items].slice(0, 2));
      setPollingMinutesLeft(15);
      openModalConfirm(type);
    }
  };
  const updateUser = async (type, submit, checkData = dataCheck) => {
    if (validateForm(type, checkData)) {
      if (type === "mail") {
        user.send_type = 'email';
        setIsSendMail(true);
      } else if (type === "phone_number") {
        user.send_type = 'phone_number';
        setIsSendMail(false);
      } else if (type === "files") {
        user.send_type = 'files';
        updateUserField('send_type', 'files')
        setIsSendMail(false);
      }
      let body = {
        ...user,
        data_check: {
          ...checkData,
        },
        data_update: {
          update_type: user.update_type,
          content: contentUpdate,
          // đổi ngân hàng: gửi thêm mã ngân hàng + số tài khoản để BE không phải tách từ content (ví USDT không có mã)
          ...(user.update_type === "bank" && dataUpdate.bank_code && {
            bank_code: dataUpdate.bank_code,
            bank_number: dataUpdate.bank_number,
          }),
        }
      };
      setLoading(true)
      let checkDataOld = await apiCheckDataAccount(body);
      setLoading(false)
      if (checkDataOld) {
        if (type === "files" && !submit) {
          let descriptionFileUpload = uploadDescriptions.length > 0
            ? "Bạn vui lòng tải lên ít nhất " + minFiles + "/" + uploadDescriptions.length + " hình ảnh/video dưới để xác minh tài khoản<br/><br/>"
            : "Bạn vui lòng tải lên ít nhất " + minFiles + " hình ảnh/video để xác minh tài khoản<br/><br/>";
          uploadDescriptions.forEach((element, index) => {
            descriptionFileUpload += (index + 1) + ". " + element + "</br>";
          });
          descriptionFileUpload = "<p>" + descriptionFileUpload + "</p>";
          setInfoFileUpload(descriptionFileUpload)
          setOpenUploadFile(true);
          return;
        }
        let confirmUpdate = checkDataOld.result;
        let value_auto_check = confirmUpdate ? "check_success" : "check_fail";
        updateUserField("auto_check", value_auto_check);
        body.auto_check = value_auto_check;
        //nếu thông tin đúng hết hoặc đã nhập lại từ 5 lần và có số điện thoại hoặc email đúng thì tự động confirm gửi yêu cầu
        const verificationMatched =
          (type === "mail" && checkDataOld.submitEmail === 1) ||
          (type === "phone_number" && checkDataOld.submitPhoneNumber === 1);
        if (
          confirmUpdate ||
          verificationMatched ||
          (type === "files" && submit) ||
          (timesCheckData >= 100 && checkDataOld.allowSubmit > 0)
        ) {
          confirmUpdateUser(body, type);
        } else {
          setLoading(false)
          Swal.fire({
            icon: "warning",
            title: "Chú ý",
            text: type === "mail"
              ? "Quý khách nhập không đúng Email đã liên kết, vui lòng kiểm tra lại thông tin hoặc sử dụng cách khác."
              : "Quý khách nhập không đúng SĐT đã liên kết, vui lòng kiểm tra lại thông tin hoặc sử dụng cách khác.",
            showCancelButton: true,
            cancelButtonText: "Nhập lại",
            showConfirmButton: false,
            reverseButtons: true
          }).then((result) => {
            if (result.isDismissed) {
              setTimesCheckData((currentTimes) => currentTimes + 1);
              if (type === "mail" || type === "phone_number") {
                modalConfirmUpdate(type, checkData);
              }
            }
          });
        }
      }
    }
  };
  const closeModalConfirm = () => {
    setOpenConfirm(false);
    navigate("/profile", { state: {userName, data: { ...data, recent_requests: recentRequests }, webSetting} });
  };

  const refreshSubmittedRequest = async () => {
    if (!submittedRequest?.request_code) return;
    setIsRefreshingRequest(true);
    setRequestRefreshMessage("");
    const result = await apiGetRequestHistory(user.account, submittedRequest.request_code);
    if (result?.code === 200 && result?.data?.request) {
      setSubmittedRequest(result.data.request);
      setRequestRefreshMessage(`Đã cập nhật trạng thái mới nhất lúc ${new Date().toLocaleTimeString("vi-VN")}.`);
    } else {
      setRequestRefreshMessage("Không thể cập nhật trạng thái. Vui lòng thử lại.");
    }
    setIsRefreshingRequest(false);
  };

  const copySubmittedRequestCode = async () => {
    try {
      await navigator.clipboard.writeText(submittedRequest.request_code);
      Swal.fire({ icon: "success", text: "Đã sao chép mã yêu cầu.", timer: 1500, showConfirmButton: false });
    } catch (error) {
      Swal.fire({ icon: "error", text: "Không thể sao chép mã yêu cầu." });
    }
  };

  const handleMediaUpload = async (event) => {
    const files = Array.from(event.target.files);
    let totalSize = selectedFiles.reduce((acc, file) => acc + file.size, 0);
    const validFiles = files.filter((file) => {
      if (file.size > 50 * 1024 * 1024) {
        Swal.fire({
          icon: "error",
          title: "Thất bại!",
          text: `File ${file.name} vượt quá giới hạn 50MB.`,
        });
        return false;
      }
      if (totalSize + file.size > 50 * 1024 * 1024) {
        Swal.fire({
          icon: "error",
          title: "Thất bại!",
          text: "Tổng kích thước các file vượt quá giới hạn 50MB.",
        });
        return false;
      }
      totalSize += file.size;
      return true;
    });
    
    setSelectedFiles((prevFiles) => [...prevFiles, ...validFiles]);
    const newPreviews = validFiles.map((file) => ({
      url: URL.createObjectURL(file),
      type: file.type.startsWith("image") ? "image" : "video"
    }));
    if (previews.length + newPreviews.length > 7) {
      Swal.fire({
        icon: "error",
        title: "Thất bại!",
        text: "Hệ thống yêu cầu tối đa 7 file",
      });
      return;
    }
    const base64Images = await Promise.all(
      validFiles.map((file) => {
        return new Promise((resolve, reject) => {
          const reader = new FileReader();
          reader.readAsDataURL(file);
          reader.onloadend = () => resolve(reader.result);
          reader.onerror = reject;
        });
      })
    );
    setPreviews((prevPreviews) => [...prevPreviews, ...newPreviews]);
    setSelectedImage((prevImages) => [...prevImages, ...base64Images]);
  };

  const handleRemoveImage = (index) => {
    setPreviews((prevPreviews) => prevPreviews.filter((_, i) => i !== index));
    setSelectedImage((prevImages) => prevImages.filter((_, i) => i !== index));
    setSelectedFiles((prevFiles) => prevFiles.filter((_, i) => i !== index));
  };

  return (
    <div className="container">
      {(loading) && (
        <Loading loading={loading}/>
      )}
      <div className="content">
        <motion.div
          className="app"
          initial={{ x: "100vw", opacity: 0 }}
          animate={{ x: 0, opacity: 1 }}
          exit={{ x: "-100vw", opacity: 0 }}
          transition={{ type: "spring", stiffness: 1000, damping: 200, duration: 10 }}
        >
          <Header isPageSearch={false} pageToAcction={"/profile"} data={ {userName, data, webSetting} } currentPage={typeModal}/>

          <div className="content">
          <div className="content-container-pc">
            {/* <Popup open={open} onClose={() => {setOpen(false); document.body.style.overflow = 'auto';}} position={"center"} closeOnDocumentClick={false} nested> */}
              <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }} transition={{ duration: 0.5 }} id="modal-info" className="modal-info">
                {/* <div className="info-current">
                  <Collapsible open={false} trigger={["THÔNG TIN CÁ NHÂN", <img src={iconArrow} key="icon-arrow" alt="icon-arrow" />]}>
                    <InfoUser />
                  </Collapsible>
                </div> */}
                <div className="confirm-info-old">
                  <span className="modal-titlte">VUI LÒNG NHẬP LẠI THÔNG TIN ĐÃ LIÊN KẾT</span>
                  <div className="input-info">
                    <input type="text" name="name" value={dataCheck.name} onChange={inputDataCheck} placeholder="Họ Và Tên" />
                    {errors.name && <p className="error">{errors.name}</p>}
                    {/* <select type="input" name="bank_name" value={dataCheck.bank_name} onChange={inputDataCheck} isClearable isSearchable>
                      <option value="">Chọn ngân hàng/Ví USDT</option>
                      {config.LIST_BANK_NAME.map((bank, index) => (
                        <option key={index} value={bank}>
                          {bank}
                        </option>
                      ))}
                    </select> */}
                    <SelectSearch
                      className="select-search"
                      placeholder="Chọn ngân hàng/Ví USDT"
                      options={bankOptions}
                      onChange={selectBankCheck}
                      styles={{
                        control: (base) => ({
                          ...base,
                          border: "none",
                          boxShadow: "none",
                          backgroundColor: "transparent",
                          color: "#34A749",
                          padding: "0",
                          margin: "0",
                          textAlign: "left",
                        }),
                        valueContainer: (base) => ({
                          ...base,
                          justifyContent: "left",
                          padding: 0,
                        }),
                        input: (base) => ({
                          ...base,
                          color: "#34A749",
                          padding: "0",
                          textAlign: "left",
                        }),
                        singleValue: (base) => ({
                          ...base,
                          padding: "0",
                          color: "#34A749",
                          textAlign: "left",
                          marginLeft: "auto",
                        }),
                        placeholder: (base) => ({
                          ...base,
                          textAlign: "left",
                          marginLeft: "auto",
                          fontWeight: 300,
                          color: "#767676",
                        }),
                        menu: (base) => ({
                          ...base,
                          borderRadius: "8px",
                          boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
                          marginTop: "4px",
                        }),
                        menuList: (base) => ({
                          ...base,
                          padding: "4px 0",
                        }),
                        option: (base, state) => ({
                          ...base,
                          textAlign: "left",
                          padding: "10px 15px",
                          backgroundColor: state.isSelected 
                            ? "#2F80ED" 
                            : state.isFocused 
                            ? "#E6F0FF" 
                            : "#FFFFFF",
                          color: state.isSelected ? "#FFFFFF" : "#34A749",
                          cursor: "pointer",
                          "&:active": {
                            backgroundColor: state.isSelected ? "#2F80ED" : "#E6F0FF",
                          },
                        }),
                      }}
                    />
                    {/* <input type="text" name="bank_name" value={dataCheck.bank_name} onChange={inputDataCheck} placeholder="Ngân Hàng" /> */}
                    {errors.bank_name && <p className="error">{errors.bank_name}</p>}
                    <input type="text" name="bank_number" value={dataCheck.bank_number} onChange={inputDataCheck} placeholder={placeholderCheckBankNumber} />
                    {errors.bank_number && <p className="error">{errors.bank_number}</p>}
                  </div>
                </div>
                <div className="confirm-info-new">
                  {isContactInfoFlow && (
                    <>
                      <span className="modal-titlte">THAY ĐỔI SỐ ĐIỆN THOẠI / EMAIL</span>
                      <div className="input-info">
                        <select
                          style={{ paddingTop: "0px" }}
                          value={typeModal === "contact_info" ? "" : typeModal}
                          onChange={(event) => {
                            setTypeModal(event.target.value || "contact_info");
                            setErrors((currentErrors) => ({
                              ...currentErrors,
                              contactInfoType: "",
                            }));
                          }}
                        >
                          <option value="">Chọn thông tin cần thay đổi</option>
                          {!disabledUpdateTypes.includes("phone_number") && <option value="phone_number">Thay đổi số điện thoại</option>}
                          {!disabledUpdateTypes.includes("email") && <option value="email">Thay đổi email</option>}
                        </select>
                        {errors.contactInfoType && <p className="error">{errors.contactInfoType}</p>}
                      </div>
                    </>
                  )}
                  <>
                  {
                    {
                      "forget_password": <span className="modal-titlte">CẤP LẠI MẬT KHẨU ĐĂNG NHẬP</span>,
                      "forget_password_withdraw": <span className="modal-titlte">CẤP LẠI MẬT KHẨU RÚT TIỀN</span>,
                      "full_name": 
                      <>
                        <span className="modal-titlte">THAY ĐỔI HỌ TÊN MỚI</span>
                        <div className="input-info">
                          <input type="text" name="name" onChange={inputDataUpdate} placeholder="Họ Tên Mới" />
                          {errors.nameUpdate && <p className="error">{errors.nameUpdate}</p>}
                        </div>
                      </>,
                      "phone_number": 
                      <>
                        <span className="modal-titlte">THAY ĐỔI SỐ ĐIỆN THOẠI MỚI</span>
                        <div className="input-info">
                          <input type="text" name="phone_number" onChange={inputDataUpdate}  placeholder="Số Điện Thoại Mới" />
                          {errors.phoneNumberUpdate && <p className="error">{errors.phoneNumberUpdate}</p>}
                        </div>
                      </>,
                      "email": 
                      <>
                        <span className="modal-titlte">THAY ĐỔI EMAIL MỚI</span>
                        <div class="input-info">
                          <input type="text" name="email" onChange={inputDataUpdate} placeholder="Email Mới" />
                          {errors.emailUpdate && <p className="error">{errors.emailUpdate}</p>}
                        </div>
                      </>,
                      "bank": 
                      <>
                        <span className="modal-titlte">{desChangeBank.title_change_bank}</span>
                        <div className="input-info">
                          <select type="input" name="bank_type_change" onChange={inputDataUpdate}>
                            <option value="">Chọn yêu cầu thay đổi</option>
                            {config.LIST_REQUEST_BANK.map((bank, index) => (
                              <option key={index} value={bank}>
                                {bank}
                              </option>
                            ))}
                          </select>
                          {errors.bankTypeChange && <p className="error">{errors.bankTypeChange}</p>}
                          
                          {/* <select type="input" name="bank_name" onChange={inputDataUpdate}>
                            <option value="">Chọn Ngân Hàng/Ví USDT Mới</option>
                            {config.LIST_BANK_NAME.map((bank, index) => (
                              <option key={index} value={bank}>
                                {bank}
                              </option>
                            ))}
                          </select> */}
                          <SelectSearch
                            className="select-search"
                            placeholder="Chọn ngân hàng/Ví USDT"
                            options={bankOptions}
                            onChange={selectBankUpdate}
                            styles={{
                              control: (base) => ({
                                ...base,
                                border: "none",
                                boxShadow: "none",
                                backgroundColor: "transparent",
                                color: "#34A749",
                                padding: "0",
                                margin: "0",
                                textAlign: "left",
                              }),
                              valueContainer: (base) => ({
                                ...base,
                                justifyContent: "left",
                                padding: 0,
                              }),
                              input: (base) => ({
                                ...base,
                                color: "#34A749",
                                padding: "0",
                                textAlign: "left",
                              }),
                              singleValue: (base) => ({
                                ...base,
                                padding: "0",
                                color: "#34A749",
                                textAlign: "left",
                                marginLeft: "auto",
                              }),
                              placeholder: (base) => ({
                                ...base,
                                textAlign: "left",
                                marginLeft: "auto",
                                fontWeight: 300,
                                color: "#767676",
                              }),
                              menu: (base) => ({
                                ...base,
                                borderRadius: "8px",
                                boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
                                marginTop: "4px",
                              }),
                              menuList: (base) => ({
                                ...base,
                                padding: "4px 0",
                              }),
                              option: (base, state) => ({
                                ...base,
                                textAlign: "left",
                                padding: "10px 15px",
                                backgroundColor: state.isSelected 
                                  ? "#2F80ED" 
                                  : state.isFocused 
                                  ? "#E6F0FF" 
                                  : "#FFFFFF",
                                color: state.isSelected ? "#FFFFFF" : "#34A749",
                                cursor: "pointer",
                                "&:active": {
                                  backgroundColor: state.isSelected ? "#2F80ED" : "#E6F0FF",
                                },
                              }),
                            }}
                          />
                          {/* <input type="text" name="bank_name" onChange={inputDataUpdate} placeholder={desChangeBank.bank_name} /> */}
                          {errors.bankNameUpdate && <p className="error">{errors.bankNameUpdate}</p>}
                          <input type="text" name="bank_number" onChange={inputDataUpdate} placeholder={desChangeBank.bank_number} />
                          {errors.bankNumberUpdate && <p className="error">{errors.bankNumberUpdate}</p>}
                        </div>
                      </>,
                      "birthday":
                      <div className="input-info">
                        <input type="date" name="birth_day" onChange={inputDataUpdate} placeholder="ngày tháng năm sinh" defaultValue="2000-12-01"/>
                        {errors.birthDayUpdate && <p className="error">{errors.birthDayUpdate}</p>}
                      </div>,
                    }[typeModal]
                  }
                  </>
                </div>
                <div className="mode-verify">
                  <span className="modal-titlte">VUI LÒNG LỰA CHỌN HÌNH THỨC GỬI XÁC THỰC</span>
                  {(typeModal !== "birthday") &&
                  <>
                    <div className="action action-verify">
                      { data.email &&
                      <button onClick={() => modalConfirmUpdate("mail")} className="action-verify-btn">
                        <img src={iconSendMail} alt="icon-bank" />
                        &nbsp; XÁC THỰC EMAIL
                      </button>
                      }
                      { data.phone_number &&
                      <button onClick={() => modalConfirmUpdate("phone_number")} className="action-verify-btn">
                        <img src={iconSendPhone} alt="icon-bank" />
                        &nbsp; XÁC THỰC SĐT
                      </button>
                      }
                    </div>
                    <p className='note-verify-image'>
                      Nếu quý khách không có email hoặc SDT để gửi thông tin, vui lòng nhấn nút dưới đây để thực hiện thay thế
                    </p>
                  </>
                  }
                  <div className="action action-verify">
                    <button id="confirm_files_btn" onClick={() => modalConfirmUpdate("files")}>
                      <img src={iconImage} alt="icon-bank" />
                        &nbsp;&emsp; TẢI LÊN HÌNH ẢNH VIDEO THAY THẾ XÁC THỰC
                    </button>
                  </div>
                </div>
              </motion.div>
            {/* </Popup> */}
            <Popup open={openConfirm} closeOnDocumentClick={false} onClose={closeModalConfirm} position={"center"} nested>
              <motion.div
                initial={{ opacity: 0, y: 75 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.5 }}
                id="modal-confirm"
                className="modal-confirm"
              >
                <div className="modal-close">
                  <a className="icon-close" onClick={closeModalConfirm} >
                    <img style={{ width: "30px", height: "30px"}} src={iconBack} alt="icon-close" />
                  </a>
                </div>
                  {/* {user.send_type === 'files' ? (
                    <div className="modal-confirm-content">
                      <img style={{ marginBottom: "20px" }} src={iconSuccess} alt="icon-success" />
                      <span>Yêu cầu của quý khách của quý khách đã được ghi nhận. Vui lòng đợi xét duyệt.</span>
                      <div className="btn-wrapper-home">
                        <div className="btn-send btn-home">
                            <a href={ webSetting.link_home }
                                target="_blank"
                                rel="noopener noreferrer">VỀ TRANG CHỦ
                            </a>
                        </div>
                      </div>
                      <div className="notification">
                        <p style={{ color: "#34A749", padding: "3px 0px",margin: "0px"}}>Lưu ý:</p>
                        <p>- Quý khách vui lòng kiểm tra kết quả xử lý của hệ thống tại Hòm Thư.</p>
                        <p>- Liên hệ <a href={ webSetting.link_cskh }
                          target="_blank"
                          rel="noopener noreferrer">CSKH</a> nếu cần hỗ trợ thêm.</p>
                    </div>
                    </div>
                  ): ( */}
                <div className="modal-confirm-content">
                  <img className="icon-warning" src={iconWarning} />
                  {isSendMail ? (
                    <p>
                      Vui lòng sử dụng email đã liên kết <span style={{ color: "green" }}>{data.email === "not_check" ? "" : data.email }</span> gửi thư tới email OK9{" "}
                      <span style={{ color: "red" }}>{ webSetting.email }</span>, với nội dung:
                    </p>
                  ) : user.send_type === 'phone_number' ? (
                    <p>
                      Vui lòng sử dụng số điện thoại đã liên kết <span style={{ color: "green" }}>{data.phone_number === "not_check" ? "" : data.phone_number}</span> gửi tin nhắn tới số điện thoại OK9{" "}
                      <span style={{ color: "red" }}>{ webSetting.phone_number }</span>, với nội dung:
                    </p>
                  ) : (
                    <p>
                      Yêu cầu của quý khách của quý khách đã tiếp nhận. Vui lòng lưu lại mã yêu cầu để có thể xem lại lịch sử xét duyệt khi cần.
                    </p>
                  )}
                  <DataConfirm user={user}
                  dataCheck = {dataCheck}
                  dataUpdate = {dataUpdate}
                  webSetting = {webSetting}
                  idUserUpdate = {idUserUpdate}/>
                  {submittedRequest && <div className={`request-processing-status status-${submittedRequest.status}`}>
                    {submittedRequest.status === "no_process" && <div className={`request-live-update-notice ${pollingMinutesLeft === 0 ? "request-live-update-stopped" : ""}`} role="status" aria-live="polite">
                      {pollingMinutesLeft > 0 ? <span className="request-loading-icon" aria-hidden="true" /> : <span className="request-update-paused-icon" aria-hidden="true">✓</span>}
                      <div>
                        <strong>{pollingMinutesLeft > 0 ? "Hệ thống đang cập nhật trạng thái" : "Xử lý chưa hoàn tất."}</strong>
                        <small>{pollingMinutesLeft > 0 ? "Vui lòng giữ màn hình này mở và chờ kết quả xử lý." : "Bạn có thể bấm Kiểm tra lại để lấy trạng thái mới nhất."}</small>
                      </div>
                    </div>}
                    <strong className="request-processing-title">
                      {submittedRequest.status === "approved"
                        ? "Yêu cầu đã được xử lý thành công"
                        : submittedRequest.status === "removed"
                          ? "Yêu cầu đã bị từ chối"
                          : ["email", "phone_number"].includes(submittedRequest.send_type) && submittedRequest.verification_status !== "success"
                            ? "Yêu cầu đang chờ xác thực"
                            : pollingMinutesLeft > 0
                              ? "Yêu cầu đang được xử lý"
                              : "Yêu cầu đang được xử lý lâu hơn dự kiến"}
                    </strong>
                    <p>Mã yêu cầu: <strong>{submittedRequest.request_code}</strong></p>
                    {submittedRequest.note && <div className="request-result-note"><strong>Kết quả xử lý:</strong><HtmlNote html={submittedRequest.note} /></div>}
                    <div className="request-progress">
                      <div className="request-progress-step step-complete"><span>1</span><small>Đã gửi yêu cầu</small></div>
                      <div className={`request-progress-step ${!["email", "phone_number"].includes(submittedRequest.send_type) || submittedRequest.verification_status === "success" ? "step-complete" : submittedRequest.verification_status === "invalid" ? "step-error" : "step-current"}`}><span>2</span><small>{["email", "phone_number"].includes(submittedRequest.send_type) ? "Xác thực" : "Đã tiếp nhận"}</small></div>
                      <div className={`request-progress-step ${submittedRequest.status === "approved" ? "step-complete" : submittedRequest.status === "removed" ? "step-error" : ["email", "phone_number"].includes(submittedRequest.send_type) && submittedRequest.verification_status !== "success" ? "step-pending" : "step-current"}`}><span>3</span><small>Đang xử lý</small></div>
                      <div className={`request-progress-step ${submittedRequest.status === "approved" ? "step-complete" : submittedRequest.status === "removed" ? "step-error" : "step-pending"}`}><span>4</span><small>Hoàn tất</small></div>
                    </div>
                    {submittedRequest.status === "no_process" && <div className="request-processing-message">
                      {submittedRequest.verification_status === "not_received" && submittedRequest.send_type === "email" && <p>Chưa nhận xác thực. Vui lòng gửi email bằng địa chỉ đã liên kết.</p>}
                      {submittedRequest.verification_status === "not_received" && submittedRequest.send_type === "phone_number" && <p>Chưa nhận xác thực. Vui lòng gửi SMS bằng số điện thoại đã liên kết.</p>}
                      {submittedRequest.verification_status === "invalid" && <p>Xác thực không hợp lệ. Vui lòng kiểm tra email/số điện thoại và gửi lại.</p>}
                      {pollingMinutesLeft === 0 && <><p>Yêu cầu đang xử lý lâu hơn dự kiến.</p><div className="request-processing-actions"><button type="button" onClick={refreshSubmittedRequest} disabled={isRefreshingRequest}>{isRefreshingRequest ? "Đang kiểm tra..." : "Kiểm tra lại"}</button><button type="button" onClick={copySubmittedRequestCode}>Sao chép mã</button><a href={webSetting?.link_cskh} target="_blank" rel="noopener noreferrer">Liên hệ CSKH</a></div>{requestRefreshMessage && <p className="request-refresh-message" role="status">{requestRefreshMessage}</p>}</>}
                    </div>}
                  </div>}
                  <div className="notification">
                    <p>- Liên hệ <a href={ webSetting.link_cskh }
                      target="_blank"
                      rel="noopener noreferrer">CSKH</a> nếu cần hỗ trợ thêm.</p>
                </div>
                </div>
                {/* )} */}
              </motion.div>
            </Popup>
            <Popup open={openResult} onClose={() => setOpenResult(false)} position={"center"}>
              <motion.div initial={{ opacity: 0, y: 50 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.5 }} className="modal-success">
                <div className="modal-close">
                  <a className="icon-close" onClick={() => setOpenResult(false)}>
                    <img src={iconClose} alt="icon-close" />
                  </a>
                </div>
                {checkConfirm ? (
                  <div className="modal-result-content">
                    <img style={{ marginBottom: "20px" }} src={iconSuccess} alt="icon-success" />
                    <span>Chúng tôi đã nhận được yêu cầu của Quý khách, vui lòng chờ 2-5 phút và nhận kết quả phản hồi tại Hòm thư nội bộ</span>
                  </div>
                  ) : (
                  <div className="modal-result-content">
                    <img style={{ marginBottom: "20px" }} src={iconWarning} alt="icon-success" />
                    <span>Yêu cầu của bạn chưa được ghi nhận, vui lòng thử lại hoặc liên hệ chăm sóc khách hàng</span>
                  </div>
                )}
              </motion.div>
            </Popup>
            <Popup open={openUploadFile} onClose={() => setOpenUploadFile(false)} position={"center"}>
              <motion.div initial={{ opacity: 0, y: 50 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.5 }} className="modal-success">
                <div className="modal-close">
                  <a className="icon-close" onClick={() => setOpenUploadFile(false)}>
                    <img src={iconClose} alt="icon-close" />
                  </a>
                </div>
                  <div className="modal-result-content">
                    <img style={{ marginBottom: "20px" }} src={iconWarning} alt="icon-success"/>
                    <span>Bạn cần cung cấp thêm hình ảnh/video để xác minh thông tin.</span>
                    
                    <Typography
                      variant="body2"
                      color="textSecondary"
                      sx={{
                        color: "black",
                        marginBottom: "-10px",
                        marginTop: "-15px",
                        fontWeight: "bold",
                      }}
                    >
                      <div className='upload-file' dangerouslySetInnerHTML={{ __html: infoFileUpload }}/>
                    </Typography>
                    <Box
                      display="flex"
                      alignItems="center"
                      marginY={1}
                      flexWrap="wrap"
                      gap="8px 8px"
                    >
                      {previews.map((preview, index) => (
                        
                        <Box
                          onClick={() => handleRemoveImage(index)}
                          key={index}
                          sx={{
                            maxHeight: 80,
                            maxWidth: 90,
                            width: "auto",
                            height: "auto",
                            position: "relative",
                            overflow: "hidden",
                            cursor: "pointer",
                            "&:hover .delete-button": {
                              display: "block",
                            },
                          }}
                        >
                        {preview.type === "image" ? (
                          <img
                            src={preview.url}
                            alt={`preview-${index}`}
                            style={{
                              width: "auto",
                              maxWidth: "100%",
                              height: "auto",
                              maxHeight: "100%",
                              borderRadius: 4,
                              objectFit: "cover",
                            }}
                            />
                          ) : (
                            <video
                              src={preview.url}
                              controls
                              style={{
                                width: "auto",
                                maxWidth: "100%",
                                height: "auto",
                                maxHeight: "100%",
                                borderRadius: 4,
                                objectFit: "cover",
                              }}
                            />
                          )}
                            <IconButton
                              className="delete-button"
                              sx={{
                                position: "absolute",
                                top: 0,
                                right: 0,
                                color: "red",
                                p: 0,
                              }}
                            >
                              <Close fontSize="small" />
                            </IconButton>
                          </Box>
                        ))}
                        
                        <Box>
                          <input
                            accept="image/*, video/*"
                            style={{ display: "none" }}
                            id="upload-button"
                            type="file"
                            onChange={handleMediaUpload}
                            multiple
                          />
                          <label htmlFor="upload-button">
                            <Button
                              variant="outlined"
                              component="span"
                              startIcon={
                                <AddPhotoAlternateOutlined
                                  sx={{ fontSize: "large" }}
                                />
                              }
                              sx={{
                                width: "90px",
                                height: "80px",
                                color: "#6BB0C8",
                                borderColor: "#6BB0C8",
                                borderStyle: "solid",
                                "&:hover": {
                                  borderColor: "#6BB0C8",
                                  color: "#6BB0C8",
                                },
                              }}
                            >
                              Thêm
                            </Button>
                          </label>
                        </Box>
                      </Box>
                      <Typography variant="caption" sx={{ color: "#B0B3C1" }}>
                        Cung cấp hình ảnh/video đúng theo mô tả để được xét duyệt
                      </Typography>
                      {selectedImage.length >= minFiles && (
                        <div>
                          <button id="complete_files_btn" onClick={() => {setOpenUploadFile(false); updateUser(user.send_type, true)}}>
                            Hoàn thành xác minh
                          </button>
                        </div>
                      )}
                  </div>
              </motion.div>
            </Popup>
          </div>
          </div>
        </motion.div>
      </div>
    </div>
  );
}

export default ChangeInfo;
